export const imageCaptionCanvasStyles = `
                .sio-image-caption.sio-image-caption--editing {
                    min-height: 1.75em;
                    cursor: text;
                }

                .sio-image-caption.sio-image-caption--editing:empty::before,
                .sio-image-caption.sio-image-caption--editing:has(> br:only-child)::before {
                    content: "Bildunterschrift eingeben…";
                    color: #9ca3af;
                    pointer-events: none;
                }

                .sio-image-caption--hidden {
                    display: none !important;
                }
`;
